module.exports = __webpack_public_path__ + "img/close_2.3e3e6b61.svg";